import { render, staticRenderFns } from "./FlowForm.vue?vue&type=template&id=3f5fba4c&"
import script from "./FlowForm.vue?vue&type=script&lang=js&"
export * from "./FlowForm.vue?vue&type=script&lang=js&"
import style0 from "./FlowForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports